import React, { useContext, useState, useEffect } from "react";

import Breadcrumb from "../components/Breadcrumb";
import CardPreview from "../components/CardPreview";
import EditCardTheme from "../components/EditCardTheme";
import EditColor from "../components/EditColor";

import SideMenu from "../components/SideMenu";
import Navbar from "../components/Navbar";

import { AuthContext } from "../context/AuthContext";

function Appearance() {
  const { userData } = useContext(AuthContext);
  const [theme, setTheme] = useState(userData.theme);
  const [color, setColor] = useState(userData.color);
  const [displayColor, setDisplayColor] = useState(null);

  const changeColor = (value) => {
    setColor(value);
  };
  const changeTheme = (value) => {
    setTheme(value);
  };

  useEffect(() => {
    if (color >= 0 && color <= 365) {
      setDisplayColor(`hsl(${color}, 50%, 50%)`);
    } else if (color <= 0) {
      setDisplayColor("#e4e4e4");
    } else {
      setDisplayColor("#2b2a2a");
    }
  }, [color, displayColor]);

  useEffect(() => {
    document.title = "Appearance";
    return () => {
      document.title = "Flipcard";
    };
  }, []);

  return (
    <>
      {userData && (
        <>
          <Navbar />
          <div className="content">
            <div className="side-left">
              <SideMenu />
            </div>
            <div className="side-right">
              <Breadcrumb title="Appearance" />
              <CardPreview theme={theme} color={displayColor} />
              <EditCardTheme theme={theme} changeTheme={changeTheme} />
              <EditColor color={color} changeColor={changeColor} />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Appearance;
